import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../../components/Header/Header";
import { useAuth } from "../../context/AuthContext";
import { apiError } from "../../api/client";
import "./Auth.scss";

export default function Signup() {
  const { register } = useAuth();
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) {
      setError("Password must be at least 8 characters");
      return;
    }
    setSubmitting(true);
    try {
      await register(name, email, password);
      navigate("/quiz", { replace: true });
    } catch (err) {
      setError(apiError(err, "Could not create your account"));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth">
      <Header />
      <main className="auth__card rise-1">
        <span className="auth__eyebrow">Join ClassiFind</span>
        <h1 className="auth__title">Start your collection</h1>
        <p className="auth__subtitle">Save the classical finds you love.</p>

        <form className="auth__form" onSubmit={handleSubmit} noValidate autoComplete="off">
          {error && (
            <p className="auth__error" role="alert">
              {error}
            </p>
          )}

          <label className="auth__label" htmlFor="name">
            Name
          </label>
          <input
            id="name"
            type="text"
            className="auth__input"
            autoComplete="off"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />

          <label className="auth__label" htmlFor="email">
            Email
          </label>
          <input
            id="email"
            type="email"
            className="auth__input"
            autoComplete="off"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <label className="auth__label" htmlFor="password">
            Password
          </label>
          <input
            id="password"
            type="password"
            className="auth__input"
            autoComplete="off"
            minLength={8}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <p className="auth__hint">At least 8 characters.</p>

          <button className="auth__submit" type="submit" disabled={submitting}>
            {submitting ? "Creating…" : "Sign up"}
          </button>
        </form>

        <p className="auth__switch">
          Already have an account? <Link to="/login">Log in</Link>
        </p>
      </main>
    </div>
  );
}
